import { IDeletePesquisaSatisfacaoUseCase } from "../../../presentation/useCases/delete/delete_pesquisa_satisfacao_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeletePesquisaSatisfacaoUseCase
 */

export class DeletePesquisaSatisfacaoUseCase implements IDeletePesquisaSatisfacaoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async deletePesquisaSatisfacao(
    idPesquisaSatisfacao: number,
  ): Promise<void> {
    await this.repository.deletePesquisaSatisfacao(idPesquisaSatisfacao);
  }
}
